/**
 * Which build of the app this is.
 *
 * Substituted by Vite at build time ([`vite.config.ts`](../vite.config.ts)), so
 * there is nothing to fetch and nothing to keep in sync — the value is a string
 * literal in the bundle by the time a browser sees it.
 *
 * **Only the app's own version lives here.** The content version is not the
 * client's to report: the server knows which course a learner is on and what
 * version it was seeded at, so it fills that in itself. A field the client
 * supplies is a field a stale client gets wrong, and the whole point of these
 * two strings is triage.
 */

declare const __APP_VERSION__: string | undefined;

/**
 * The build stamp, or `unknown`.
 *
 * `unknown` is reachable and deliberately not an error: the tests import this
 * module without Vite's substitution, and a build made where git is unavailable
 * has nothing truthful to say.
 */
export const appVersion = (): string =>
  typeof __APP_VERSION__ === 'string' && __APP_VERSION__ !== ''
    ? __APP_VERSION__
    : 'unknown';
